/* drawer.js */

document.addEventListener('DOMContentLoaded', function() {
  const hamburger = document.querySelector('.js-drawer-open');
  const closeBtn = document.querySelector('.js-drawer-close');
  const overlay = document.querySelector('.js-drawer-overlay');
  const drawer = document.querySelector('.js-side-drawer');
  const body = document.body;
  const submenuTriggers = document.querySelectorAll('.drawer-submenu-trigger, .drawer-more-trigger');
  const backButtons = document.querySelectorAll('.drawer-back');

  console.log('Drawer initialized');
  console.log('Submenu triggers found:', submenuTriggers.length);
  console.log('Back buttons found:', backButtons.length);

  function openDrawer() {
    console.log('Opening drawer');
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    body.style.overflow = 'hidden'; // Prevent scrolling
  }

  function closeDrawer() {
    console.log('Closing drawer');
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    body.style.overflow = ''; // Restore scrolling
    closeSubmenu(); // Also close any open submenu
  }

  function openSubmenu(submenuId) {
    console.log('Opening submenu:', submenuId);
    drawer.classList.add('has-active-submenu');
    const submenu = document.getElementById(submenuId);
    if (submenu) {
      console.log('Submenu found:', submenu);
      submenu.classList.add('is-active');
    } else {
      console.error('Submenu not found:', submenuId);
    }
  }

  function closeSubmenu() {
    console.log('Closing submenu');
    drawer.classList.remove('has-active-submenu');
    document.querySelectorAll('.drawer-slide-submenu').forEach(slide => {
      slide.classList.remove('is-active');
    });
  }

  if (hamburger) {
    hamburger.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      closeDrawer();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function() {
      closeDrawer();
    });
  }

  // Submenu Trigger Click
  submenuTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      const submenuId = this.getAttribute('data-submenu-id');
      console.log('Trigger clicked, submenu ID:', submenuId);
      openSubmenu(submenuId);
    });
  });

  // Back Button Click
  backButtons.forEach(button => {
    button.addEventListener('click', function() {
      closeSubmenu();
    });
  });

  // Handle ESC key to close drawer or submenu
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (drawer.classList.contains('has-active-submenu')) {
        closeSubmenu();
      } else {
        closeDrawer();
      }
    }
  });
});
